import {
    Box,
    Card,
    FormControl,
    Grid,
    InputLabel,
    MenuItem,
    Select,
    TextField
} from "@mui/material";
import { useEffect, useState } from "react";
import { MIDIA_OPTIONS_CALL_CENTER } from "../../constants/midia";
import { useBudgetFormContext } from "../../context/BudgetFormContext";
import { getCallStatusOptions } from "../../services/callCenterService";

const BudgetRegisterForm = () => {

    const { budgetRequest, changeBudgetRequestForm } = useBudgetFormContext();

    const [statusOptions, setStatusOptions] = useState([]);

    const midiaOptions = MIDIA_OPTIONS_CALL_CENTER;

    useEffect(() => {
        const fetchOptions = async () => {
            const options = await getCallStatusOptions(3);
            setStatusOptions(options);
        };
        fetchOptions();
    }, []);

    return (
        <Card>
            <Box sx={{ p: 3, minWidth: 1050, backgroundColor: "#f9fafb" }}>
                <Grid container spacing={3}>
                    <Grid item size={6}>
                        <FormControl fullWidth required>
                            <InputLabel id="motivo-label">Motivo</InputLabel>
                            <Select
                                error={budgetRequest.budgetMotivoError}
                                helperText={budgetRequest.budgetMotivoError && 'Escolha um motivo'}
                                labelId="motivo-label"
                                value={budgetRequest.budgetMotivo}
                                onChange={e => {
                                    changeBudgetRequestForm('budgetMotivoError', (e.target.value === 0))
                                    changeBudgetRequestForm('budgetMotivo', e.target.value)
                                }}
                                sx={{
                                    fontWeight: !budgetRequest.budgetMotivo ? 600 : 500,
                                    fontFamily: 'Montserrat',
                                    color: budgetRequest.budgetMotivoError ? '#d32f2f' : '#082b49'
                                }}
                            >
                                <MenuItem
                                    value={0}
                                    sx={{
                                        fontWeight: 600,
                                        fontFamily: 'Montserrat',
                                    }}
                                >
                                    Selecione um motivo
                                </MenuItem>
                                {statusOptions.map(item => (
                                    <MenuItem
                                        key={item.id}
                                        value={item.id}
                                        sx={{
                                            fontWeight: 500,
                                            fontFamily: 'Montserrat',
                                        }}
                                    >
                                        {item.ds_status}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item size={3}>
                        <FormControl fullWidth required>
                            <InputLabel id="midia-label">Mídia</InputLabel>
                            <Select
                                labelId="midia-label"
                                error={budgetRequest.budgetMidiaError}
                                helperText={budgetRequest.budgetMidiaError && 'Escolha uma midia'}
                                value={budgetRequest.budgetMidia}
                                onChange={(e) => {
                                    changeBudgetRequestForm("budgetMidiaError", (e.target.value === 0))   
                                    changeBudgetRequestForm("budgetMidia", e.target.value)
                                }}
                                sx={{color: budgetRequest.budgetMidiaError ? '#d32f2f' : '#082b49'}}
                            >
                                <MenuItem 
                                    value={0}
                                    sx={{
                                        fontWeight: 600,
                                        fontFamily: 'Montserrat',
                                    }}
                                >
                                    Selecione uma mídia
                                </MenuItem>
                                {midiaOptions.map((midia) => (
                                    <MenuItem key={midia.id} value={midia.ds_midia}>
                                        {midia.ds_midia}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item size={6}>
                        <TextField
                            fullWidth
                            label="Observação"
                            multiline
                            minRows={2}
                            value={budgetRequest.budgetObservacao}
                            onChange={(e) => changeBudgetRequestForm('budgetObservacao' ,e.target.value)}
                        />
                    </Grid>
                </Grid>
            </Box>
        </Card>
    );
};


export default BudgetRegisterForm;
